import { render } from "./karussellSwiperEnergie.vue?vue&type=template&id=b2501dac"
import script from "./karussellSwiperEnergie.vue?vue&type=script&lang=js"
export * from "./karussellSwiperEnergie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__